import { render } from "./MainStaffLoans.vue?vue&type=template&id=60665b8a&scoped=true"
import script from "./MainStaffLoans.vue?vue&type=script&lang=js"
export * from "./MainStaffLoans.vue?vue&type=script&lang=js"

import "./MainStaffLoans.vue?vue&type=style&index=0&id=60665b8a&scoped=true&lang=css"

import exportComponent from "D:\\Sistema\\Nueva carpeta\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60665b8a"]])

export default __exports__